<template>
  <div>
    <Topside />
    <div class="main">
      <RepoSearch />
      <div class="box box-hg">
        <div class="boxtitle">検索一覧</div>
        <div class="box-1 box-2">
          <div class="kaisou3">
            <table class="kaisou-tbl">
              <colgroup>
                <col span="1" style="width:120px;" />
                <col span="1" style="width:auto; background-color:#fff;" />
              </colgroup>
              <thead>
                <th>RIIS参照コード</th>
                <th>標題</th>
              </thead>
              <tbody>
                <tr>
                  <td>{{parentData.Code1}}/{{parentData.Code2}}</td>
                  <td>{{parentData.Title}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="kaisou3">
            <p>該当件数：{{cntAll}}件</p>
            <div class="kaisou2-show">
              <table class="kaisou-tbl tblcolor">
                <colgroup>
                  <col span="1" style="width:30px;" />
                  <col span="1" style="width:80px;" />
                  <col span="1" style="width:auto; background-color:#fff;" />
                </colgroup>
                <thead>
                  <th>No</th>
                  <th>RIIS参照コード</th>
                  <th>標題</th>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in pageData" :key="index">
                    <td>{{getItemNo+index+1}}</td>
                    <td>{{item.Code1}}/{{item.Code2}}/{{item.Code3}}</td>
                    <td>
                      <a href="javascript:void(0);" @click="clickData(item)">{{item.Title}}</a>
                    </td>
                  </tr>
  
                </tbody>
              </table>
            </div>
          </div>
          <div>

          <form class="cp_ipselect cp_sl01">
            <select v-model="listCount">
            <option hidden>表示件数</option>
                <option selected>5</option>
                <option>10</option>
                <option>20</option>
                <option>50</option>
            </select>
          </form>
        
          <paginate class="page-select" :page-count="pageAllCnt" :page-range="5" :margin-pages="2" :click-handler="clickPageNo" :prev-text="'Prev'" :next-text="'Next'" :next-class="'next'" :prev-class="'prev'" :container-class="'pager'" :page-class="'page-item'" v-model="pageNo">
          </paginate>

          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>

<style lang="css">
  .pager {
    overflow: hidden;
    margin: 10px;
  }
  
  .pager li {
    margin: 0 1px;
    position: relative;
    float: left;
    list-style: none;
  }
  
  li.page-item.active a {
    background-color: #aaa !important;
  }
  
  .pager li a {
    display: block;
    font-size: 16px;
    padding: 0.6em 1em;
    border-radius: 3px;
    background: #eee;
    color: #000;
    text-decoration: none;
    list-style: none;
  }
  
  .pager li a:hover {
    background: #333;
    color: #fff;
  }
  
  .page-select {
    float: left;
  }
  
  .page-box {
    height: 30px;
    width: 50px;
    position: relative;
    top: 10px;
    float: right;
  }
  
  .kaisou2-show {
    max-height: 640px;
    overflow-y: auto;
  }
</style>

<script>
  import Topside from '@/components/Treeside'
  import RepoSearch from '@/components/RepoSearch'
  import axios from 'axios'
  import {
    KAISO2_LIST_CNT
  } from '@/services/config'
  export default {
    name: 'Kaiso2',
    components: {
      Topside,
      RepoSearch
  
    },
    watch: {
      /**
       * ページ番号の変化をWatch
       */
      pageNo: function() {
        this.getPageData()
      },
      listCount: function() {
        var self = this;
        self.pageAllCnt = self.cntAll / self.listCount
        self.pageAllCnt = Math.ceil(self.pageAllCnt)
        self.getPageData()
      }
    },
  
    computed: {
      /**
       * ページ番号を返す
       */
      getItemNo() {
        return this.itemNo
      }
    },
  
    data() {
      return {
        kaisoData: [] /* 第2階層の全ページ分の階層データ */ ,
        parentData: [] /* 親階層のデータ */ ,
        pageData: [] /* 親データ（2階層目) */ ,
        cntAll: 0 /* データ件数 */ ,
        pageAllCnt: 0 /* ページ数 */ ,
        pageNo: 1 /* ページ番号 */ ,
        itemNo: 1 /* レコード番号 1〜 */ ,
        listCount: 10 /* 1ページの表示数　*/
      }
    },
    /**
     * URLの変更時に呼ばれる
     */
    beforeRouteUpdate(to, from, next) {
      //別階層へ変更した場合
      if (
        !(from.params.Code1 === to.params.code1 ||
        !from.params.Code2 === to.params.code2 ||
        !from.params.Code3 === to.params.code3)
      ){
        //ページ番号初期化
        this.cntAll = 0
        this.pageAllCnt = 0
        this.pageNo = 1
        this.itemNo = 1
      }
      /*ADD-190408 表示ページ階層判断用 */
      this.$store.dispatch('upSelMenuId', `${to.params.code1}/${to.params.code2}`)

      this.getKaisoData(to.params.code1, to.params.code2)
      next()
    },
    /**
     * 起動時 Mount されるとき呼ばれる
     */
    mounted() {
      this.getKaisoData(this.$route.params.code1, this.$route.params.code2)

     /*ADD-190408 表示ページ階層判断用 */
      this.$store.dispatch('upSelMenuId2', '')
    },
    methods: {
      /**
       * 第２階層に表示する階層データを作成
       */
      getKaisoData(code1, code2) {
        var self = this
        this.getAllKaisoData(function(res) {
          if (res == null) {
            self.kaisodata = self.$store.getters.kaiso1tbl
            self.parentData = self.$store.getters.kaiso1tbl.find(item => {
              return item.Code1 === code1 && item.Code2 === code2
            })
            self.kaisoData = self.$store.getters.kaiso2tbl.filter(function(
              item,
              index
            ) {
              // Code1 Code2 が同じなら表示対象
              if (item.Code1 === code1 && item.Code2 === code2) return true
            })
            self.cntAll = self.kaisoData.length
            self.pageAllCnt = 0
            if (self.cntAll > 0) {
              self.pageAllCnt = self.cntAll / self.listCount
              self.pageAllCnt = Math.ceil(self.pageAllCnt)
            }
            self.getPageData()
          }
        })
      },
      /**
       * ページ番号のクリック処理
       */
      clickPageNo(v) {
        this.pageNo = v
      },
      /**
       * データクリック処理
       * 概要：第３階層のリストを開く
       */
      clickData(item) {
        this.$router.push(`/database/${item.Code1}/${item.Code2}/${item.Code3}`)
      },
      /**
       * 概要ページのデータを取得
       */
      getPageData() {
        var startIdx = (this.pageNo - 1) * this.listCount
        this.itemNo = startIdx
        //var endIdx = startIdx + this.listCount
        var endIdx = Number(startIdx) + Number(this.listCount)
        this.pageData = this.kaisoData.slice(startIdx, endIdx)
      },
    }
  }
</script>
